import { Title } from "@vds3/typography";
import React from "react";
import { MarginSpacerM } from "../../../Checkout/styleTag";
import DueMonthlyPrint from "./Component/DueMonthlyPrint";



const OrderSummaryPrint = (props)=>{
    return(
        <div >
        <Title size="medium" bold>Order summary </Title>
        <MarginSpacerM/>
        <DueMonthlyPrint {...props}/>
        </div>
    )
}

export default OrderSummaryPrint